import { HelpTooltip } from '@/presentation/components/common/HelpTooltip';
import {
  ownerStatusBadgeClass,
  type OwnerStatusTone,
} from '@/application/metrics/pvpRetentionPresentation';

type OwnerStatusBadgeProps = {
  label: string;
  tip: string;
  tone: OwnerStatusTone;
  testId?: string;
  uppercase?: boolean;
};

/**
 * Badge de estado dueño + “¿qué significa?”.
 * El número PVP usa `MetricDefinitionTooltip` (`metricId="pvp"`); este tip es solo el estado.
 */
export function OwnerStatusBadge({
  label,
  tip,
  tone,
  testId = 'owner-status-badge',
  uppercase = true,
}: OwnerStatusBadgeProps) {
  return (
    <span className="inline-flex items-center gap-1">
      <span
        data-testid={testId}
        data-tone={tone}
        className={`rounded px-1.5 py-0.5 text-[11px] font-bold tracking-wide ${
          uppercase ? 'uppercase' : ''
        } ${ownerStatusBadgeClass(tone)}`}
      >
        {label}
      </span>
      <HelpTooltip content={tip} size="sm" ariaLabel={tip} align="start" stopPropagation />
    </span>
  );
}
